import type { RetrieveSelfTenantResponse } from "@/services/retrieveSelfTenant"
import { api } from "@/api"
import type { FileExportFormat } from "@/composables/options/useFileExportFormatOptions"

export type PartialUpdateTenant = Partial<{
  accessControlRestrictTransactions: boolean
  accessControlRestrictReports: boolean
  isHospitalityEnabled: boolean
  isCashEnabled: boolean
  isGratuityEnabled: boolean
  isTransactionReceiptsEnabled: boolean
  isReceiptQrCodeEnabled: boolean
  isCardReceiptsEnabled: boolean
  isAutomaticMerchantReceiptEnabled: boolean
  isProductsEnabled: boolean
  isCashiersEnabled: boolean
  isServiceChargeEnabled: boolean
  isSplitPaymentsEnabled: boolean
  isCollectionEnabled: boolean
  isTablesEnabled: boolean
  isOpenOrdersEnabled: boolean
  defaultServiceChargePercentage: number | null
  defaultServiceChargeFlat: number | null
  defaultExportFiletype: FileExportFormat
  isVatEnabled: boolean
  defaultVatRate: number | null
  vatNumber: string
}>

export const partialUpdateSettings = async (
  params: Partial<PartialUpdateTenant>
) => {
  const { body } =
    await api.patch<RetrieveSelfTenantResponse>(
      "/settings/",
      {
        body: params,
      }
    )
  return body
}
